import { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

const Footer = ({ centerId }: { centerId: string | undefined }) => {
  const [isOpen, setIsOpen] = useState({
    myAccount: false,
    aboutUs: false,
    legalInfo: false,
    information: false,
  });

  const toggleLinks = (section: string) => {
    setIsOpen((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const handleOnClick = () => window.scrollTo(0, 0);
  const withDialog = window.location.pathname.includes('withdialog');

  if (!centerId) {
    return <div>Error: No center selected</div>;
  }

  const appendWithDialog = withDialog ? '/withdialog' : '';

  return (
    <footer>
      <div className='footer-block'>
        <div className='footer-header' onClick={() => toggleLinks('myAccount')}>
          <span>My Account</span>
          {isOpen.myAccount ? <FaChevronUp /> : <FaChevronDown />}
        </div>
        <div className={classNames('footer-links', { open: isOpen.myAccount })}>
          <Link to={`/center/${centerId}${appendWithDialog}/my-account`} className='item' onClick={handleOnClick}>
            My account
          </Link>
          <Link to={`/center/${centerId}${appendWithDialog}/loyalty-rewards`} className='item' onClick={handleOnClick}>
            Loyalty Rewards
          </Link>
          <Link
            to={`/center/${centerId}${appendWithDialog}/transaction-history`}
            className='item'
            onClick={handleOnClick}
          >
            Transaction history
          </Link>
        </div>
      </div>

      <div className='footer-block'>
        <div className='footer-header' onClick={() => toggleLinks('aboutUs')}>
          <span>About us</span>
          {isOpen.aboutUs ? <FaChevronUp /> : <FaChevronDown />}
        </div>
        <div className={classNames('footer-links', { open: isOpen.aboutUs })}>
          <Link to={`/center/${centerId}${appendWithDialog}/contact`} className='item' onClick={handleOnClick}>
            Contact
          </Link>
          <Link to={`/center/${centerId}${appendWithDialog}/registration`} className='item' onClick={handleOnClick}>
            Registration
          </Link>
          <Link to={`/center/${centerId}${appendWithDialog}/loyalty`} className='item' onClick={handleOnClick}>
            Loyalty
          </Link>
          <Link to={`/center/${centerId}${appendWithDialog}/newsletter`} className='item' onClick={handleOnClick}>
            Newsletter
          </Link>
        </div>
      </div>

      <div className='footer-block'>
        <div className='footer-header' onClick={() => toggleLinks('legalInfo')}>
          <span>Legal Information</span>
          {isOpen.legalInfo ? <FaChevronUp /> : <FaChevronDown />}
        </div>
        <div className={classNames('footer-links', { open: isOpen.legalInfo })}>
          <Link to={`/center/${centerId}${appendWithDialog}/terms`} className='item' onClick={handleOnClick}>
            Terms
          </Link>
          <Link to={`/center/${centerId}${appendWithDialog}/imprint`} className='item' onClick={handleOnClick}>
            Imprint
          </Link>
          <Link to={`/center/${centerId}${appendWithDialog}/consents`} className='item' onClick={handleOnClick}>
            My Consents
          </Link>
          <Link to={`/center/${centerId}${appendWithDialog}/privacy`} className='item' onClick={handleOnClick}>
            Privacy
          </Link>
        </div>
      </div>

      <div className='footer-block'>
        <div className='footer-header' onClick={() => toggleLinks('information')}>
          <span>Informations</span>
          {isOpen.information ? <FaChevronUp /> : <FaChevronDown />}
        </div>
        <div className={classNames('footer-links', { open: isOpen.information })}>
          <Link to={`/center/${centerId}/retail-details`} className='item' onClick={handleOnClick}>
            Retail details
          </Link>
          <Link to={`/center/${centerId}${appendWithDialog}/embeddedShop`} className='item' onClick={handleOnClick}>
            Embedded Shop
          </Link>
          <Link to={`/center/${centerId}/voucher-list`} className='item' onClick={handleOnClick}>
            Voucher List
          </Link>
          <Link
            to={`/center/${centerId}${appendWithDialog}/voucher-verification`}
            className='item'
            onClick={handleOnClick}
          >
            Voucher verification
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
